<template>
  	<DnsListBatchWise />
</template>

<script>

// @ is an alias to /src
import DnsListBatchWise from "../components/DnsListBatchWise.vue";

export default {
  name: "DnsListBatchWises",
  components: {
    DnsListBatchWise,
  },
};
</script>
